import { environment } from '@environment/environment';
import { ContentfulMetadata, Sys } from '@generated/graphql';
import { LazyImage } from '@models/lazy-image';

export interface LazyImageSizeOptions {
    quality: string;
    lqip: string;
    image: string;
    image2x: string;
    fit: string;
    fm: string; // Not set by default
    focus: string;
}

export function fixAssetUrl(url: string) {
    return (url || '')
        .replace(
            'https://images.ctfassets.net',
            'https://images.followalice.com'
        )
        .replace(`/${environment.contentful.space}`, '');
}

export function fakeAsset(url: string, altText: string) {
    return {
        url: url,
        description: altText,
        sys: { id: 'FAKE' } as Sys,
        contentfulMetadata: {} as ContentfulMetadata,
    };
}

export function lazyImageFromUrl(
    url: string,
    altText?: string,
    options?: Partial<LazyImageSizeOptions>
) {
    const opts = Object.assign(
        {
            quality: 'q=85',
            lqip: 'w=32',
            image: 'w=600',
            image2x: 'w=800',
            fit: 'fit=fill',
            focus: 'f=center',
        },
        options
    );

    const { lqip, image, image2x, ...generalOpts } = opts;
    const generalQuery = Object.values(generalOpts);

    if (url) {
        url = fixAssetUrl(url);
        const lqipQuery = [lqip, ...generalQuery].join('&');
        const imageQuery = [image, ...generalQuery].join('&');
        const image2xQuery = [image2x, ...generalQuery].join('&');

        return new LazyImage({
            original: url,
            lqip: `${url}?${lqipQuery}`,
            image: `${url}?${imageQuery}`,
            image2x: `${url}?${image2xQuery}`,
            altText: altText || '',
        });
    } else {
        return new LazyImage();
    }
}
